// src/components/community/CommunityHeader.jsx

import { motion } from "framer-motion";
import {
    Users,
    ShoppingBag,
    ArrowLeft,
    BadgeCheck
} from "lucide-react";

import { useNavigate } from "react-router-dom";

export default function CommunityHeader({

    community,

    members,

    posts,

    online,

    onShop

}){

    const navigate = useNavigate();

    return(

        <motion.div

            initial={{
                opacity:0,
                y:-30
            }}

            animate={{
                opacity:1,
                y:0
            }}

            className="
                relative
                overflow-hidden
                rounded-[34px]
                border
                border-white/20
                bg-white/60
                backdrop-blur-2xl
                shadow-xl
            "

        >

            {/* Background */}

            <img

                src={community.heroImage}

                className="
                    absolute
                    inset-0
                    w-full
                    h-full
                    object-cover
                    opacity-20
                "

                alt=""

            />

            <div
                className={`
                    absolute
                    inset-0
                    bg-gradient-to-r
                    ${community.gradient}
                    opacity-20
                `}
            />

            <div className="relative p-8">

                <div
                    className="
                        flex
                        flex-col
                        lg:flex-row
                        justify-between
                        gap-8
                    "
                >

                    {/* LEFT */}

                    <div>

                        <button

                            onClick={()=>navigate(-1)}

                            className="
                                mb-6
                                flex
                                items-center
                                gap-2
                                text-gray-600
                            "

                        >

                            <ArrowLeft size={18}/>

                            Back

                        </button>

                        <div
                            className="
                                flex
                                items-center
                                gap-4
                            "
                        >

                            <img

                                src={community.logo}

                                className="
                                    w-16
                                    h-16
                                    rounded-full
                                    border-4
                                    border-white
                                "

                                alt=""

                            />

                            <div>

                                <h1
                                    className="
                                        text-4xl
                                        font-black
                                    "
                                >

                                    {community.title}

                                </h1>

                                <div
                                    className="
                                        mt-2
                                        flex
                                        items-center
                                        gap-2
                                        text-gray-600
                                    "
                                >

                                    <BadgeCheck
                                        size={18}
                                        className="text-blue-500"
                                    />

                                    Official Community

                                </div>

                            </div>

                        </div>

                        <p
                            className="
                                mt-6
                                max-w-2xl
                                text-gray-600
                                leading-8
                            "
                        >

                            {community.description}

                        </p>

                    </div>

                    {/* RIGHT */}

                    <div
                        className="
                            grid
                            grid-cols-2
                            gap-5
                            min-w-[320px]
                        "
                    >

                        <Stat
                            icon={<Users/>}
                            value={members}
                            title="Members"
                        />

                        <Stat
                            icon={<BadgeCheck/>}
                            value={posts}
                            title="Threads"
                        />

                        <Stat
                            icon={<Users/>}
                            value={online}
                            title="Online"
                        />

                        <button

                            onClick={onShop}

                            className={`
                                rounded-3xl
                                text-white
                                font-semibold
                                ${community.button}
                                flex
                                items-center
                                justify-center
                                gap-3
                            `}

                        >

                            <ShoppingBag/>

                            Shop

                        </button>

                    </div>

                </div>

            </div>

        </motion.div>

    );

}

function Stat({

    icon,

    value,

    title

}){

    return(

        <div
            className="
                rounded-3xl
                bg-white/80
                backdrop-blur-xl
                border
                border-white/20
                p-5
            "
        >

            <div className="text-blue-600">

                {icon}

            </div>

            <div
                className="
                    mt-3
                    text-3xl
                    font-black
                "
            >

                {value}

            </div>

            <div
                className="
                    text-gray-500
                    mt-1
                "
            >

                {title}

            </div>

        </div>

    );

}